<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-19 11:03:15
 * @LastEditTime: 2022-11-02 15:59:12
 * @Description: 收款记录
 * @Param:
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\collectionRecord\index.vue
 -->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles collectionRecord">
            <van-nav-bar
                title="收款记录"
                left-text="首页"
                left-arrow
                @click-left="swiperright"
            >
                <van-icon
                    class="iconfont iconshaixuan"
                    slot="right"
                    @click="showPopup()"
                ></van-icon>
            </van-nav-bar>
            <section class="van-pull-refresh">
                <div class="queryCriteria">
                    <div class="times" @click="showCalendar = true;">
                        <p>{{ begin_time }}</p>
                        <span>—</span>
                        <p>{{ end_time }}</p>
                    </div>
                    <div>
                        <van-search v-model="Keywords" placeholder="请输入搜索内容" @change="search"></van-search>
                    </div>
                </div>
                <div class="list_header">
                    <p class="iconfont iconweizhi">
                        场站：{{ stationName }}
                    </p>
                    <p class="iconfont iconcaiwuguanli">
                        收款方式：{{ proceedsModeName }}
                    </p>
                </div>
                <div class="list">
                    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                        <van-list
                            v-model="isUpLoading"
                            :finished="finished"
                            finished-text="没有更多了!"
                            @load="onLoad"
                            :immediate-check="false"
                        >
                            <ul class="list_content">
                                <template v-for="(item, index) in listData">
                                    <li :key="`list_${index}`">
                                        <div class="engineeringInfo" @click="collectionRecordEdit(item, index)">
                                            <h4 class="engineeringInfo_header">
                                                <span
                                                    class="state notSubmitted"
                                                    v-if="item.approval_status == 0"
                                                >
                                                    <i>未提交</i>
                                                </span>
                                                <span
                                                    class="state submitted"
                                                    v-if="item.approval_status == 1"
                                                >
                                                    <i>已提交</i>
                                                </span>
                                                <span
                                                    class="state confirmed"
                                                    v-if="item.approval_status == 2"
                                                >
                                                    <i>已确认</i>
                                                </span>
                                                <span
                                                    class="state returned"
                                                    v-if="item.approval_status == 3"
                                                >
                                                    <i>已退回</i>
                                                </span>
                                                <span class="headerName">{{ item.contract_number }}</span>
                                            </h4>
                                            <div class="engineeringInfo_content">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                    <span>收款编号:{{ item.proceeds_number }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                    <span>客户名称：{{ item.client_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_2.png" alt="">
                                                    <span>工程名称：{{ item.engineering_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_26.png" alt="">
                                                    <span>本期实收：{{ item.official_receipt }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                    <span>收款日期：{{ item.receipt_date }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                    <span>场站：{{ item.station_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_5.png" alt="">
                                                    <span>收款方式：{{ item.proceeds_mode_name }}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="btns-con">
                                            <div @click="deleteInfo(item, index)">
                                                <i class="btn">删除</i>
                                            </div>
                                            <div @click="recordAssociation(item)">
                                                <i class="btn">关联</i>
                                            </div>
                                            <div @click="openRecordSublist(item)">
                                                <i class="btn">查看</i>
                                            </div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </van-list>
                    </van-pull-refresh>
                </div>
                <van-calendar
                    type="range"
                    :min-date="minDate"
                    v-model="showCalendar"
                    @confirm="onConfirm"
                    color="#3495FB"
                ></van-calendar>
                <button class="addBtns iconfont iconicon-test" @click="addCollectionRecord()"></button>
            </section>
            <van-popup
                class="sideslip"
                v-model="popupShow"
                position="right"
                :style="{ width: '80%',height: '100%' }"
            >
                <div class="screen">
                    <van-nav-bar
                        title="筛选"
                        right-text="取消"
                        @click-right="popupShow = false"
                    >
                    </van-nav-bar>
                    <section>
                        <dl>
                            <dt>场站</dt>
                            <dd>
                                <template v-for="(item, index) in stationData">
                                    <p
                                        :key="`station_${index}`"
                                        :class="{'active_station': item.station_id == stationID}"
                                        @click="selectStation(item)"
                                    >
                                        {{ item.name }}
                                    </p>
                                </template>
                            </dd>
                        </dl>
                        <dl>
                            <dt>收款方式</dt>
                            <dd>
                                <template v-for="(item, index) in proceedsMode">
                                    <p
                                        :key="`proceedsMode_${index}`"
                                        :class="{'active_collection': item.code == proceedsModeCode}"
                                        @click="selectProceedsMode(item)"
                                    >
                                        {{ item.name }}
                                    </p>
                                </template>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="resetSelect">
                            重置
                        </button>
                        <button @click="confirmSelect">
                            确定
                        </button>
                    </footer>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
import util from '@/utils/util';

export default {
    name: 'collection-record',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'collection-record');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 【筛选】
            popupShow: false,
            // 场站数据【筛选】
            stationData: [{
                name: '全部',
                station_id: '',
            }],
            stationName: '全部',
            stationID: '',
            // 收款方式
            proceedsMode: [{
                name: '全部',
                code: '',
            }],
            proceedsModeName: '全部',
            proceedsModeCode: '',

            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 分页
            pageindex: 1,
            // 列表总条数
            total: 0,
            // 列表数据
            listData: [],

            Keywords: '',
            begin_time: '',
            end_time: '',

            // 【时间段选择】
            showCalendar: false,
            // 时间控件最小时间
            minDate: new Date(2000, 0, 1),
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.editCallback) {
            if (this.$route.params.listIndex) {
                this.listData[this.$route.params.listIndex] = this.$route.params.row;
                this.listData[this.$route.params.listIndex].approval_status = 1;
            } else {
                this.onRefresh();
            }
        }
    },
    async created() {
        const year = new Date().getFullYear();
        this.begin_time = year + '-01-01';
        this.end_time = util.currentTimeFormat('yyyy-MM-dd');

        this.stationData.push(...await this.getStationData());
        this.proceedsMode.push(...await this.getProceedsModeData());

        await this.gitListData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 打开筛选
        showPopup() {
            this.popupShow = true;
        },
        // 输入框查询
        search() {
            this.onRefresh();
        },
        // 选择场站
        selectStation(rew) {
            this.stationName = rew.name;
            this.stationID = rew.station_id;
        },
        // 选择收款方式
        selectProceedsMode(rew) {
            this.proceedsModeName = rew.name;
            this.proceedsModeCode = rew.code;
        },
        // 重置筛选
        resetSelect() {
            this.stationName = '';
            this.stationID = '';
            this.proceedsModeName = '';
            this.proceedsModeCode = '';
            this.onRefresh();
            this.popupShow = false;
        },
        // 确认筛选
        confirmSelect() {
            this.onRefresh();
            this.popupShow = false;
        },
        // 选择时间
        onConfirm(date) {
            const [start, end] = date;
            this.showCalendar = false;
            this.begin_time = this.formatDate(start);
            this.end_time = this.formatDate(end);
            this.onRefresh();
        },
        // 格式化时间
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },

        // 下拉刷新
        onRefresh() {
            this.pageindex = 1;
            this.listData = [];
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.pageindex++;
            this.gitListData();
        },

        // 删除收款记录
        async deleteInfo(row, index) {
            const deleteRow = await this.deleteInfoRequest(row.apid);
            if (deleteRow) {
                this.listData.splice(index, 1);
                this.$toast.success('删除成功');
            }
        },

        // 获取列表数据
        async gitListData() {
            const res = await this.gitListDataRequest();
            if (res.rows.length > 0) {
                this.total = res.total;
                if (this.listData.length < 1 ) {
                    this.listData = res.rows;
                    this.finished = false;
                } else {
                    this.listData.push(...res.rows);
                }
                if (this.listData.length === this.total) {
                    this.finished = true;
                }
            } else {
                this.finished = true;
            }
            this.isLoading = false;
            this.isUpLoading = false;
            this.$forceUpdate();
        },

        // 记录关联
        recordAssociation(row) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'recordAssociation',
                params: {
                    row: row,
                },
            });
        },

        // 查看
        openRecordSublist(row) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'recordList',
                params: {
                    row: row,
                },
            });
        },

        // 收款记录编辑
        collectionRecordEdit(row, index) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'addCollectionRecord',
                params: {
                    row: row,
                    type: 'edit',
                    listIndex: index,
                    parentName: 'collectionRecord',
                },
            });
        },

        // 新增收款记录
        addCollectionRecord() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'addCollectionRecord',
                params: {
                    parentName: 'collectionRecord',
                },
            });
        },

        // 获取场站数据
        async getStationData() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationLs = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                return stationLs;
            }
            return [];
        },

        // 获取收款方式选项
        getProceedsModeData() {
            return this.$axios.$get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=601-FK0&type=6', { defEx: true });
        },

        // 获取列表数据请求
        gitListDataRequest() {
            // eslint-disable-next-line max-len
            return this.$axios.$get(`/interfaceApi/sale/accounts/proceeds/get_accounts_proceeds_list?keyword=${this.Keywords}&receipt_date_begin=${this.begin_time}&receipt_date_end=${this.end_time}&station_id=${this.stationID}&proceeds_mode=${this.proceedsModeCode}&pageindex=${this.pageindex}&pagesize=2`, { defEx: true });
        },

        // 删除记录请求
        deleteInfoRequest(apid) {
            return this.$axios.$post(`/interfaceApi/sale/accounts/proceeds/delete/${apid}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.collectionRecord
    height 100%
    overflow-y auto
    section
        height calc(100% - 44rpx)
        position relative
        .queryCriteria
            height 44rpx
            background #fff
            display flex
            justify-content space-between
            div
                flex 1
                &.times
                    padding 0 14rpx
                    display flex
                    justify-content space-between
                    font-size 12rpx
                    line-height 44rpx
                    color #333333
                    span
                        color #979EA7
                .van-search
                    padding: 10rpx 14rpx;
                    background #fff !important
                    .van-search__content
                        border 1px solid #D7D7D7
        .list_header
            padding 0 14rpx
            height 36rpx
            display flex
            background #F0F0F0
            justify-content space-between
            p
                font-size 14rpx
                line-height 36rpx
                color #333333
        .list
            padding 0
            height calc(100% - 80rpx)
            background #F0F0F0
            .van-pull-refresh
                height 100%
                overflow scroll
                -webkit-overflow-scrolling touch
                .list_content
                    padding 0 14rpx
                    background #F0F0F0
                    li
                        width 100%
                        background #fff
                        overflow hidden
                        margin-bottom 15rpx
                        position relative
                        strong
                            color #d60110
                            position absolute
                            top 46rpx
                            right 15rpx
                        .engineeringInfo
                            .state
                                &.notSubmitted
                                    background-color #FF6600
                                &.submitted
                                    background-color #3495FB
                                &.confirmed
                                    background-color #00A84B
                                &.returned
                                    background-color #D6010F
        .addBtns
            width 45rpx
            height 45rpx
            border-radius 50%
            background #1577D2
            font-size 24rpx
            line-height 45rpx
            color #fff
            border none
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35)
            position absolute
            bottom 15rpx
            right 15rpx
    .screen
        height 100%
        section
            dd
                p
                    &.active_station,
                    &.active_collection
                        background #FEE5E5 !important
                        color #E60000
</style>

